import gql from 'graphql-tag'
export default gql`
  mutation createUploadUrl ($input:UploadUrlInput!) {
    createUploadUrl (input: $input) {
      SignedUrl{
        action
        expires
        url
        name
        seconds
      }
      uploadID
      contentType
    }
  }
`